import * as React from 'react';
import { Component } from 'react';
import * as PropTypes from 'prop-types';

const propTypes = {
    installment: PropTypes.string
};

export interface IMonthlyInstallmentUIProps {
    installment: string;
}

export interface IMonthlyInstallmentUIState {
}

export default class MonthlyInstallmentUI extends Component<IMonthlyInstallmentUIProps, IMonthlyInstallmentUIState> {

    static defaultProps = {
        installment: '$--'
    };

    constructor(props) {
        super(props);
    }

    render() {
        const { installment } = this.props;

        return (
            <div className="dr-ui-monthly-payment text-center">
                <span className="value">{installment}</span>
                <span className="postfix">/mo</span>
            </div>
        );
    }

}

